import { Button, Col, Row } from "antd";
import { Link } from "react-router-dom";
import Sticky from "react-stickynode";

export const NavBar = () => {
  return (
    <Sticky top={0} innerZ={99998}>
      <Row justify="left" style={{ backgroundColor: "white" }}>
        <Col span={24} style={{ boxSizing: "border-box", padding: "10px" }}>
          <div className="primary-nav-links">
            <Link to="/">
              <Button type="link" className="fontStyleNav">
                <p>Simply Nahil</p>
              </Button>
            </Link>
            <Link to="/giving">
              <Button type="link" className="fontStyleNav">
                <p>Giving</p>
              </Button>
            </Link>
            <Link to="/biography">
              <Button type="link" className="fontStyleNav">
                <p>Biography</p>
              </Button>
            </Link>
            <Link to="/nahil-wijesuriya-endowment-fund">
              <Button type="link" className="fontStyleNav">
                <p>Endowment Fund</p>
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
    </Sticky>
  );
};
